import { render, staticRenderFns } from "./CreateReceiverAddress.vue?vue&type=template&id=2bff4f4b&"
import script from "./CreateReceiverAddress.vue?vue&type=script&lang=ts&"
export * from "./CreateReceiverAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports